import { loadable } from '../../../utils';

export const Basic = loadable(() => import('./Basic'), {});
export const Notify = loadable(() => import('./Notify'), {});
